import script from "./BlueContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueContent.vue?vue&type=script&setup=true&lang=js"

import "./BlueContent.vue?vue&type=style&index=0&id=3e7bbaf0&lang=css"

const __exports__ = script;

export default __exports__